import { render, staticRenderFns } from "./AppMainConfig.vue?vue&type=template&id=37e3140b&scoped=true&"
import script from "./AppMainConfig.vue?vue&type=script&lang=js&"
export * from "./AppMainConfig.vue?vue&type=script&lang=js&"
import style0 from "./AppMainConfig.vue?vue&type=style&index=0&id=37e3140b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e3140b",
  null
  
)

export default component.exports